import { useEffect, useState } from 'react';
import DesktopApp from './desktop/App';
import MobileApp from './mobile/App';

let timeout: any;
const BREAK_POINT = 1024;

const AppShell = () => {
  const [screenMode, setScreenMode] = useState(
    window.innerWidth > BREAK_POINT ? 'desktop' : 'mobile',
  );
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const resizeFunc = () => {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        if (window.innerWidth <= BREAK_POINT) {
          if (screenWidth > BREAK_POINT) {
            setScreenMode('mobile');
          }
        } else {
          if (screenWidth <= BREAK_POINT) {
            setScreenMode('desktop');
          }
        }
        setScreenWidth(window.innerWidth);
      }, 300);
    };
    window.addEventListener('resize', resizeFunc);
    
    return () => {
      window.removeEventListener('resize', resizeFunc);
    };
  }, [screenWidth]);
  const App = screenMode === 'desktop' ? DesktopApp : MobileApp;
  return (
    <>
      <App />
    </>
  );
};

export default AppShell;